import  {configureStore} from "@reduxjs/toolkit";
import userReducer from './userSlice'
import materialReducer from './materialsSlice'
import formulationReducer from './formulationSlice'

const store = configureStore({
    reducer:{
        user:userReducer,
        material:materialReducer,
        formulation:formulationReducer
    }
})

export default store;